import React from 'react';
import axios from 'axios';
import { DHB_API_MOBILE, isPc, DHB_API_PC, getMobileSkey } from './utils';
console.log(DHB_API_MOBILE,"DHB_API_MOBILE")
export const httpMobile = axios.create({
  timeout: 30000,
  baseURL: DHB_API_MOBILE,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

interface HttpMobilePost {
  a: string   //action
  val?: object
  c: string  // controller
  [key: string]: any
}
type HttpMobilePromise<T = any> = {
  code: number;
  data: T;
  status?: string;
};


export const httpMobilePost = <T = any,P extends HttpMobilePost = HttpMobilePost>(params:P)=>{
  return httpMobile.post<HttpMobilePromise<T>>('/api.php', params)
}

httpMobile.interceptors.request.use(
  async (config) => {
    let data = config.data || {};
    let val = data.val || {}
    if(typeof val !== 'string'){
      if(!val.skey){
        val.skey = getMobileSkey()
      }
      if(!val.source_device){
        val.source_device = 'h5_report'
      }
      if(!val.version){
        val.version = '10.6'
      }
      val = JSON.stringify(val);
      data.val = val
      let {val:_val,...search} = data
      const [path,searchString] = (config.url || '').split("?")
      let urlsObj = new URLSearchParams(searchString)
      let searchObj = {...search,...Object.fromEntries(urlsObj)}
      config.url = `${path}?${new URLSearchParams({a: searchObj.a, c: searchObj.c}).toString()}`
      config.data = data
    }
    return config;
  }
);
/**  catch axios error,捕获promise error转为同步 error返回给isErrorHttp处理   */
httpMobile.interceptors.response.use(res=>res,res=>res)